export default __webpack_public_path__ + "static/media/template-default-image.37aeb336.svg";